import React, { Component } from 'react';
import {
    View,
    TouchableOpacity,
    Text,
    Image,
    TextInput,
    Dimensions,
    Platform,
    StyleSheet,
    Keyboard
} from 'react-native';
import { observer, inject } from 'mobx-react/native';
import SizeUtil from '../../../utils/SizeUtil';
import { SelectCountryStoreModel } from '../../../stores/selectCountry';
import { Colors } from '@qnpm/q-theme';

const { scenes:{ baseColor } } = Colors;

interface Props {
    isSearchPage?: boolean;
    searchData?: any;
    searchOfloading?: boolean;

    onTextChange?: (text: string) => void;
    toggleSearchPage?: (status: boolean) => void;
}

@inject((store: SelectCountryStoreModel) => ({
    isSearchPage: store.searchBar.isSearchPage,
    searchData: store.searchBar.searchData,
    toggleSearchPage: store.searchBar.toggleSearchPage,
    onTextChange: store.searchBar.onTextChange,
    searchOfloading: store.searchBar.searchOfloading
}))
@observer
class CitySearchBar extends Component<Props> {
    public textInput: any;

    public _onChangeText = (text: string) => {
        const { onTextChange } = this.props;
        onTextChange(text);
    };
    /**
     * 暂无使用
     */
    public onSubmitEditing = (text: any) => {
        const { onTextChange } = this.props;
        onTextChange(text);
    };

    public onClearInput = () => {
        const { onTextChange } = this.props;
        onTextChange('');
    };

    public onFocus = () => {
        const { toggleSearchPage } = this.props;
        toggleSearchPage(true);
    };

    public onCancel = () => {
        const { onTextChange, toggleSearchPage } = this.props;
        this.textInput.clear();
        this.textInput.blur();
        onTextChange('');
        toggleSearchPage(false);
    };

    public onBlur = () => {
        const { searchData, toggleSearchPage } = this.props;
        if (searchData === '') {
            this.textInput.blur();
            toggleSearchPage(false);
        }
    };

    public render() {
        const { isSearchPage, searchData, searchOfloading } = this.props;
        return (
            <View style={styles.container}>
                <View style={styles.searchBar}>
                    <View style={styles.inputWrapper}>
                        <View style={styles.searchIconWrapper}>
                            <Image
                                style={styles.searchIcon}
                                source={{
                                    uri:
                                        'https://s.qunarzz.com/cmn_city_select_rn/score/assets/0.0.3/search.png'
                                }}
                            />
                        </View>
                        <TextInput
                            ref={(ref) => {
                                this.textInput = ref;
                            }}
                            style={styles.text}
                            underlineColorAndroid="transparent"
                            returnKeyType="search"
                            placeholder="请输入国家/地区中文名,全拼或代码"
                            placeholderTextColor={baseColor.text3}
                            enablesReturnKeyAutomatically
                            onSubmitEditing={this.onSubmitEditing}
                            onChangeText={this._onChangeText}
                            selectionColor="#00BCD4"
                            onFocus={this.onFocus}
                            onBlur={this.onBlur}
                            autoFocus={false}
                            value={searchData}
                        />

                        {searchData.length > 0 && searchOfloading ? (
                            <Image
                                style={{
                                    width: SizeUtil.getSize(18),
                                    height: SizeUtil.getSize(18),
                                    marginRight: 8
                                }}
                                source={{
                                    uri:
                                        'https://s.qunarzz.com/cmn_city_select_rn/score/assets/0.0.1/loadingcircle.gif'
                                }}
                            />
                        ) : (
                            !!searchData && (
                                <TouchableOpacity
                                    style={styles.iconWrapper}
                                    onPress={this.onClearInput}
                                >
                                    <Image
                                        style={{
                                            width: SizeUtil.getSize(18),
                                            height: SizeUtil.getSize(18),
                                            marginRight: 8
                                        }}
                                        source={{
                                            uri:
                                                'https://s.qunarzz.com/cmn_city_select_rn/score/assets/0.0.3/clear.png'
                                        }}
                                    />
                                </TouchableOpacity>
                            )
                        )}
                    </View>
                    {isSearchPage ? (
                        <TouchableOpacity
                            style={styles.searchBtnWrapper}
                            onPress={() => {
                                this.onCancel();
                            }}
                        >
                            <Text style={styles.searchBtnText}>取消</Text>
                        </TouchableOpacity>
                    ) : null}
                </View>
            </View>
        );
    }
}

export default CitySearchBar;

const styles = StyleSheet.create({
    container: {
        height: SizeUtil.getSize(50) + 0,
        width: Dimensions.get('window').width
    },
    searchBar: {
        marginLeft: SizeUtil.getSize(10),
        marginRight: SizeUtil.getSize(10),
        marginTop: 0,
        height: SizeUtil.getSize(44),
        flexDirection: 'row',
        alignItems: 'center'
    },
    backBtn: {
        justifyContent: 'center',
        alignItems: 'flex-start',
        width: SizeUtil.getSize(30),
        height: SizeUtil.getSize(30)
    },
    searchIconWrapper: {
        justifyContent: 'center',
        alignItems: 'center'
    },
    inputWrapper: {
        flexDirection: 'row',
        flex: 1,
        height: SizeUtil.getSize(32),
        borderRadius: 3,
        backgroundColor: '#F4F4F4',
        marginRight: SizeUtil.getSize(0),
        alignItems: 'center'
    },
    iconWrapper: {
        justifyContent: 'center',
        alignItems: 'center'
    },
    backIcon: {
        fontFamily: 'cmn_city_select_rn',
        fontSize: 18,
        paddingTop: 1,
        color: baseColor.text1,
        textAlign: 'center'
    },
    searchBtnWrapper: {
        justifyContent: 'center',
        alignItems: 'center',
        paddingLeft: SizeUtil.getSize(20),
        paddingRight: SizeUtil.getSize(10),
        height: SizeUtil.getSize(32)
    },
    searchIcon: {
        width: 13,
        height: 14,
        marginLeft: 12,
        ...Platform.select({
            ios: {
                marginRight: 10
            },
            android: {
                marginRight: 0
            }
        })
    },
    clearIcon: {
        fontSize: 18,
        paddingTop: 1,
        color: '#D4D4D4',
        marginLeft: 17,
        marginRight: 6
    },
    searchBtnText: {
        fontSize: 15,
        color: '#00bcd4',
        textAlign: 'center'
    },
    text: {
        flex: 1,
        paddingVertical: 0,
        color: '#3F4548',
        fontSize: 14
    }
});
